import { RyderEnvironment } from "@redotech/redo-model/integration/ryder/types";
import * as z from "zod/v4";

export const updateRyderIntegration = {
  name: "updateRyderIntegration" as const,
  input: z.object({
    environment: z.nativeEnum(RyderEnvironment),
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
    forceBlindReturns: z.boolean(),
    allowBlindReturnsFallback: z.boolean(),
  }),
  output: z.object({}),
};
